import { AxesResponses } from "@costory/types/endpoints/axes"

import { apiClient } from "@costory/front/lib/apiClient"

import type { SearchAcrossColumnsAndValuesResult } from "../types"

export function getAsyncData(searchQuery: string, signal: AbortSignal) {
  return new Promise<SearchAcrossColumnsAndValuesResult>((resolve, reject) => {
    signal.addEventListener("abort", () => {
      reject(new Error("Request aborted"))
    })

    apiClient
      .post<AxesResponses.Axis[]>("/axes/search", { searchQuery })
      .then((response) => {
        const result = response.data.map(({ label, name, values }) => ({
          field: name,
          label,
          values: values.map(({ label }) => label),
        }))

        resolve(result)
      })
  })
}
